var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNosotros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 32,
    viewBox: "0 0 15 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2303 16.0016C9.3563 12.9175 7.46086 10.3367 7.46086 10.3367C7.46086 10.3367 5.5681 12.9175 3.69141 16.0016C5.5681 19.083 7.46086 21.6638 7.46086 21.6638C7.46086 21.6638 9.35362 19.083 11.2303 16.0016Z",
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2306 16.0012C9.35655 19.0826 7.46112 21.6634 7.46112 21.6634C7.46112 21.6634 5.56836 19.0826 3.69166 16.0012C1.85245 19.0264 0.0292969 22.5362 0.0292969 24.5682C0.0292969 28.6723 3.35702 32 7.46112 32C11.5652 32 14.8929 28.6723 14.8929 24.5682C14.8929 22.5362 13.0698 19.0264 11.2279 15.9985L11.2306 16.0012Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.46112 0C3.35702 0 0.0292969 3.32772 0.0292969 7.43182C0.0292969 9.46379 1.85245 12.9736 3.69434 16.0014C5.57104 12.9173 7.46379 10.3365 7.46379 10.3365C7.46379 10.3365 9.35655 12.9173 11.2332 16.0014C13.0725 12.9762 14.8983 9.46647 14.8983 7.43182C14.8929 3.32772 11.5652 0 7.46112 0Z",
    fill: "#FFA692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNosotros);
export default __webpack_public_path__ + "static/media/nosotros.77365ad2415a8bdaa97ecb0918117626.svg";
export { ForwardRef as ReactComponent };